/**
 * Auth Callback Page - Handles redirect from Entra External ID
 *
 * Flow: Entra redirects here with auth code → MSAL processes it in
 * AuthProvider.handleRedirectPromise() → this page waits for completion
 * → redirects to /dashboard
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'

export function AuthCallbackPage() {
  const { inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  useEffect(() => {
    // Wait until MSAL is done processing the redirect
    if (inProgress === InteractionStatus.None) {
      if (isAuthenticated) {
        navigate('/dashboard', { replace: true })
      } else {
        // Auth failed or was cancelled — go back to login
        navigate('/login', { replace: true })
      }
    }
  }, [inProgress, isAuthenticated, navigate])

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  )
}
